<template>
    <tr :class="['clickable', { disabled: !isActive, updated: isLastVisited(entity.id) }]"
        @click="goToDetail($event, entity.id)">
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
            <span
                v-if="!$_updateActionAllowed"
                class="lock"
                :title="'Globální balíček. Nelze editovat.' | translate"
                v-translate>S
            </span>
            <input type="checkbox"
                   v-if="$_readActionAllowedAllOrOwnAndGlobal"
                   :id="entity.id"
                   :value="entity.id"
                   @click.stop
                   @change="onChange"
                   :checked="isChecked"
            />
            <label :for="entity.id" v-if="$_readActionAllowedAllOrOwnAndGlobal" @click.stop v-translate>Vybrat</label>
        </td>
      <span class="lock" v-if="!$_updateActionAllowed" 	:title="'Globální balíček. Nelze editovat.' | translate" v-translate>Zamčeno</span>
      <td :data-th="'Název' | translate"><strong>{{ entity.name }}</strong></td>
        <td :data-th="'Operátor' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <entity-link :id="entity.id_operator" type="operator">{{ entity.operator_name }}</entity-link>
        </td>
        <td :data-th="'Business model' | translate" v-if="$_readActionAllowedAllOrOwnAndGlobal">
          <span v-for="(model, index) in entity.business_models" :key="model.id">
            <entity-link :id="model.id" type="businessModel">{{ model.name }}</entity-link><span v-if="index !== Object.keys(entity.business_models).length - 1">, </span>
          </span>
        </td>
        <td :data-th="'Typ' | translate">{{ channelType() }}</td>
        <td :data-th="'Kombinace se základními' | translate">{{ channelCombinationWithBasic() }}</td>
        <td :data-th="'Kombinace s tématickými' | translate">{{ channelCombinationWithThematic() }}</td>
        <td :data-th="'Počet kanálů v balíčku' | translate" v-if="channelsCount()">
          <span class="dotted" @click.stop="$refs.channelsmodalref.showModal(true)">
                {{ channelsCount() }}
              <modal ref="channelsmodalref">
                <div slot="title"><translate>Kanály v balíčku</translate> ({{channelsCount()}})</div>
                <div slot="body">
                  <ul>
                    <li v-for="(item, index) in entity.channels" :key="'channels-'+index">{{item.name}}
                    <channel-video-quality-label v-if="item.video_quality" :quality="item.video_quality"></channel-video-quality-label>
                    </li>
                  </ul>
                </div>
              </modal>
            </span>
        </td>
      <td :data-th="'Počet kanálů v balíčku' | translate" v-else></td>
        <td :data-th="'Cena' | translate">{{ priceDisplayValue() }}</td>
        <td class="no_padding edit">
            <div class="edit_inner">
                <a
						v-if="!isActive && $_updateActionAllowed"
						class="btn btn_action btn_grey btn_enable"
												:title="'Aktivovat' | translate"
						@click.prevent.stop="emitUpdatePackage({enabled: true})"
						v-translate>Aktivovat
				</a>
                <a
						v-if="isActive && $_updateActionAllowed"
						class="btn btn_action btn_grey btn_disable"
												:title="'Deaktivovat' | translate"
						@click.prevent.stop="emitUpdatePackage({enabled: false})"
						v-translate>Deaktivovat
				</a>
                <a
                    v-if="$_deleteActionAllowed"
						class="btn btn_action btn_delete"
												:title="'Smazat' | translate"
						@click.prevent.stop="emitDeletePackage"
						v-translate>Smazat
				</a>
            </div>
        </td>
    </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import ChannelVideoQualityLabel from "../../common/ChannelVideoQualityLabel.vue";
import EntityLink from "../../common/EntityLink.vue";

export default {
		name: "PackageRow",
    mixins: [rowActions],
    components: { EntityLink, ChannelVideoQualityLabel},
    props: {
      entity: Object,
      selectedPackages: Array
    },
		data() {
			return {
				moduleName: 'packages'
			}
		},
		computed: {
			isActive: function () {
				return this.entity.enabled
			},
			isChecked: function () {
				return this.selectedPackages.indexOf(String(this.entity.id)) > -1
			}
		},
		methods: {
      priceDisplayValue() {
        return this.entity.price + ' Kč'
      },
      channelType() {
        let type = ''
        if (this.entity.type === 'basic') {
          type = this.$gettext('základní')
        }
        if (this.entity.type === 'thematic') {
          type = this.$gettext('tématický')
        }
        return type
      },
      channelCombinationWithBasic() {
        let combinationAllowed = ''
        if (this.entity.combination_with_basic === true) {
          combinationAllowed = this.$gettext('Ano')
        }
        if (this.entity.combination_with_basic === false) {
          combinationAllowed = this.$gettext('Ne')
        }
        return combinationAllowed
      },
      channelCombinationWithThematic() {
        let combinationAllowed = ''
        if (this.entity.combination_with_thematic === true) {
          combinationAllowed = this.$gettext('Ano')
        }
        if (this.entity.combination_with_thematic === false) {
          combinationAllowed = this.$gettext('Ne')
        }
        return combinationAllowed
      },
      channelsCount() {
        return this.entity.channels.length
      },
			onChange: function (e) {
				this.$emit('input', e)
			},
			goToDetail(e, id) {
				this.$router.push({name: 'packageDetail', params: {id: id}})
			},
			emitUpdatePackage(params) {
				this.$emit('updatePackage', {'id': String(this.entity.id), 'params': params})
			},
			emitDeletePackage() {
				this.$emit('deletePackage', String(this.entity.id))
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/packages/PackageRow.vue